jQuery(document).ready(function ($) {
  $(".contact-button__button").on("click", function () {
    var phoneNumber = $(this).attr("data-phone-number");

    $(this).html(phoneNumber);
  });
});
